<template>
	<div class="site-footer">
		<div class="footer-main">
			<div class="footer-left">
				<div class="foot-logo">
					<img src="@/assets/img/common/foot-logo.png"/>
				</div>
				<h2>河北伟航信息技术有限公司</h2>
				<p>热线电话：0311-86115067</p>
			</div>
			<div class="footer-center">
				<div class="foot-nav">
					<div class="foot-ul">
						<div class="foot-title">首页</div>
						<div class="foot-li">
							<ul>
								<li><a href="#product">产品中心</a></li><br/>
								<li><a href="#cooperpartner">合作伙伴</a></li>
							</ul>
						</div>
					</div>
					<div class="foot-ul">
						<div class="foot-title">产品中心</div>
						<div class="foot-li">
							<ul>
								<li><a href="/product?id=0">智慧食堂</a></li>
								<li><a href="/product?id=1">智慧考勤</a></li>
								<li><a href="/product?id=2">智慧宿舍</a></li>
								<li><a href="/product?id=3">校园出行</a></li>
								<li><a href="/product?id=5">明厨亮灶</a></li>
								<li><a href="/product?id=7">家校视讯</a></li>
								<li><a href="/product?id=4">边界预警</a></li>
								<li><a href="/product?id=6">区域综合平台</a></li>
							</ul>
						</div>
					</div>
					<div class="foot-ul">
						<div class="foot-title">解决方案</div>
						<div class="foot-li">
							<ul>
								<li><a href="/solution">行业解决方案</a></li>
							</ul>
						</div>
					</div>
					<div class="foot-ul">
						<div class="foot-title">行业案例</div>
						<div class="foot-li">
							<ul>
								<li><a href="/case">案例中心</a></li>
							</ul>
						</div>
					</div>
					<div class="foot-ul">
						<div class="foot-title">联系我们</div>
						<div class="foot-li">
							<ul>
								<li><a href="/contact">联系我们</a></li>
							</ul>
						</div>
					</div>
					
				</div>
			</div>
			<div class="footer-right">
				<img src="@/assets/img/common/erweima.png" />
				<p>微信扫描二维码</p>
			</div>
		</div>
		<div class="footer-bot">Copyright ©2023-2024 www.weihangxinxi.com 河北伟航信息技术有限公司 版权所有 <a href="https://beian.miit.gov.cn" target="_blank">冀ICP备2023005192号-1</a></div>
	</div>
</template>

<script>
	export default{
		name:'HomeFooter',
		data(){
			return{
				
			}
		},
		mounted(){
			
		},
		methods:{
			
		}
	}
</script>

<style scoped>
	.site-footer{
		width: 100%;
		height: 335px;
		background: #F0F2F5;
		padding-top: 72px;
		box-sizing: border-box;
	}
	.footer-main{
		width:1200px;
		margin: 0 auto;
		padding-bottom: 60px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
	}
	.footer-left{
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}
	.foot-logo{
		width: 105px;
		height: 53px;
		margin-bottom: 20px;
	}
	.foot-logo img{
		width: 105px;
		height: 53px;
	}
	.footer-left h2{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		margin-bottom: 20px;
	}
	.footer-left p{
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
	}
	
	
	.footer-center{
		width: 860px;
	}
	.foot-nav{
		display: flex;
		flex: 1;
		flex-direction: row;
		justify-content: space-around;
		align-items: flex-start;
	}
	.foot-ul{
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		padding-left: 20px;
	}
	.foot-title{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin-bottom: 10px;
	}
	.foot-li{
		height: 130px;
	}
	.foot-li ul{
		min-width: 100px;
		height: 100%;
		padding: 0;
	}
	.foot-li ul li{
		float: left;
		margin: 5px 0;
		margin-right: 20px;
	}
	.foot-li ul li a{
		font-size: 12px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		text-decoration: none;
	}
	.foot-li ul li a:hover{
		color: #ffb316;
	}
	
	
	
	
	.footer-right{
		width: 100px;
		height: auto;
	}
	.footer-right img{
		width: 100px;
		height: 100px;
		margin-bottom: 20px;
	}
	.footer-right p{
		font-size: 12px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		text-align: center;
	}
	
	
	.footer-bot{
		width:1200px;
		height: 38px;
		margin: 0 auto;
		border-top: #E2E2E2 1px solid;
		font-size: 12px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #B1B1B1;
		text-align: center;
		line-height: 38px;
	}
	.footer-bot a{
		color: #B1B1B1;
		text-decoration: none;
	}
</style>

<style scoped>
	@media only screen and (min-width:992px) and (max-width:1199px) {
		
		.footer-main{
			width:80%;
			margin: 0 auto;
		}
		.footer-center{
			flex: 1;
		}
		.site-footer{
			width:100%;
			height: auto;
		}
		
		.footer-bot{
			width:992px;
			margin: 0 auto;
		}
	}
	@media only screen and (min-width:768px) and (max-width:991px) {
		
		.footer-main{
			width:80%;
			margin: 0 auto;
			flex-direction: column;
			justify-content: center;
			align-items: flex-start;
		}
		.footer-center{
			flex: 1;
			width: auto;
		}
		
		.site-footer{
			width:100%;
			height: auto;
		}
		.footer-bot{
			width:768px;
			margin: 0 auto;
		}
	}
	@media (max-width:767px) {
		
		.footer-main{
			width: 100%;
			padding: 30px;
			margin: 0 auto;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}
		.foot-logo{
			margin-bottom: 10px;
		}
		.footer-left h2{
			margin-bottom: 10px;
		}
		.footer-left p{
			margin-bottom: 0;
		}
		.footer-center{
			/* flex: 1;
			width: auto; */
			width: 0;
			display: none;
		}
		.foot-nav{
			flex-direction: row;
			flex-wrap: wrap;
		}
		.foot-ul{
			padding-left: 0;
		}
		.foot-li{
			height: auto;
		}
		.foot-li ul{
			min-width: 110px;
			/* display: flex;
			flex-direction: column;
			height: auto; */
			padding-left: 0;
		} 
		.site-footer{
			width:100%;
			height: auto;
			padding: 0;
		}
		
		.footer-bot{
			width: calc(100% - 40px);
			height: 60px;
			margin: 0 auto;
			padding: 0 5%;
			line-height: 25px;
			justify-content: center;
			align-items: center;
		}
		.footer-right{
			width: 90px;
		}
		.footer-right img{
			width: 90px;
			height: 90px;
			margin-bottom: 10px;
		}
	}
</style>